import UpsellAction from './UpsellAction';

import { useMercuryPermissions } from '@/hooks/useMercuryPermissions';

import type { AccessModules } from '@/types/permissions';
import { UPSELL_FALLBACK_TITLE } from '@/constants/text/english';
import { formatRequiredModules } from '@/features/usersettings/utils/moduleDisplayName';

interface UpsellProps {
  upsellText?: string;
  /** Modules any one of which unlocks the content; omit when unknown. */
  requiredModules?: AccessModules;
  isTableTabUpsell?: boolean;
}

const Upsell = ({ upsellText, requiredModules, isTableTabUpsell = false }: UpsellProps) => {
  const titleStyle = isTableTabUpsell
    ? { fontSize: '1.25rem', marginBottom: '0.5rem' }
    : { fontSize: '2rem', marginBottom: '1rem' };

  const paragraphStyle = isTableTabUpsell
    ? { fontSize: '0.85rem', marginBottom: '0.5rem' }
    : { fontSize: '1rem', marginBottom: '1rem' };

  const containerStyle = isTableTabUpsell
    ? { padding: '1rem', textAlign: 'center' as const }
    : { padding: '2rem', textAlign: 'center' as const };

  const { hasAccess } = useMercuryPermissions();
  // A 402 for a viewer who already has one of the modules has another cause,
  // so only name modules the viewer lacks.
  const modules =
    requiredModules?.length && !hasAccess({ modules: requiredModules })
      ? formatRequiredModules(requiredModules)
      : undefined;

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>{modules ? `${modules} required` : UPSELL_FALLBACK_TITLE}</h1>

      <p style={paragraphStyle}>
        {modules ? (
          <>
            This content is part of <b>{modules}</b>, which isn&apos;t in your subscription.
          </>
        ) : (
          <>This content isn&apos;t included in your current subscription.</>
        )}
      </p>

      {upsellText && <p style={paragraphStyle}>{upsellText}</p>}

      <p style={paragraphStyle}>Please contact us to add it to your subscription.</p>

      <UpsellAction />
    </div>
  );
};

export default Upsell;
